export default "__VITE_ASSET__CJlaCEMa__"